{
  "el": {
    "project": {
      "actions": {
        "activate": "Ενεργοποίηση",
        "addProjectMaintainer": "Προσθήκη διαχειριστή έργου",
        "add_as_partner": "Προσθήκη ως συνεργάτη",
        "add_as_partner_description": "Θέλεις σίγουρα να προσθέσεις {partner} ως συνεργάτη σε αυτό το έργο;",
        "add_project_partner": "Προσθήκη συνεργάτη έργου",
        "additional_information": "Πρόσθετες πληροφορίες",
        "changeProjectLogin": "Αλλαγή εικόνας έργου",
        "changeProjectLogo": "Αλλαγή λογότυπου έργου",
        "deactivate": "Απενεργοποίηση",
        "edit": "Επεξεργασία",
        "finishRequest": "Αποστολή αιτήματος",
        "follow": "Παρακολούθηση",
        "giveAccess": "Παροχή πρόσβασης",
        "maintainerAdd": "Προσθήκη διαχειριστή έργου",
        "maintainerAddDescription": "Θέλεις σίγουρα να δώσεις πρόσβαση σε αυτό το έργο σε {maintainer};",
        "maintainerRemove": "Αφαίρεση διαχειριστή έργου",
        "maintainerRemoveDescription": "Θέλεις σίγουρα να ανακαλέσεις την πρόσβαση σε αυτό το έργο για {maintainer};",
        "new": "Έργο",
        "next": "Επόμενο",
        "remove_partner": "Αφαίρεση {partner}",
        "remove_project_partner": "Αφαίρεση συνεργάτη έργου",
        "remove_project_partner_description": "Θέλεις σίγουρα να αφαιρέσεις {partner} από τους συνεργάτες του έργου;",
        "selectOption": "Επιλογή",
        "selectTemplate": "Επιλογή προτύπου",
        "submit": "Δημιουργία έργου",
        "unFollow": "Διακοπή παρακολούθησης"
      },
      "attributes": {
        "address": "Διεύθυνση",
        "currency": "Νόμισμα",
        "delivery_date_actual": "Αναμενόμενη ημερομηνία λήξης",
        "delivery_date_contractual": "Συμβατική ημερομηνία λήξης",
        "description": "Περιγραφή",
        "internal_note": "Εσωτερική σημείωση έργου",
        "measurement": "Μονάδα μέτρησης",
        "name": "Όνομα",
        "picture_login_url": "Εικόνα έργου",
        "picture_logo_url": "Λογότυπο έργου",
        "quotity_total": "Συνολικό ποσό μεταβίβασης",
        "skip_building": "Απόκρυψη κτιρίου",
        "skip_lot": "Απόκρυψη οικοπέδου",
        "skip_phase": "Απόκρυψη φάσης",
        "skip_unit": "Απόκρυψη ακινήτου (έργο με ένα ακίνητο)",
        "start_date": "Ημερομηνία έναρξης",
        "units_count": "Αριθμός ακινήτων που δημιουργήθηκαν",
        "units_count_max": "Μέγιστος αριθμός ακινήτων",
        "vat_percentage": "ΦΠΑ %",
        "website_url": "URL ιστότοπου"
      },
      "errors": {
        "capacity": {
          "cant_have_more_units": "Έφτασες στο όριο χωρητικότητας. Επικοινώνησε μαζί μας."
        }
      },
      "import": {
        "add": "+ Προσθήκη",
        "add_instead": "Τελικά θέλω να προσθέσω {levels}",
        "building": "κτίριο",
        "buildings": "κτίρια",
        "changed_mind": "Παράλειψη αυτού του επιπέδου",
        "create_new": "{type}: ποιο είναι το όνομα;",
        "download_template": "Λήψη προτύπου εισαγωγής",
        "drop_or_upload": "Σύρε εδώ το πρότυπο ή κάνε κλικ για ανέβασμα",
        "error_line": "Σφάλμα στη γραμμή",
        "file_unreadable": "Δεν ήταν δυνατή η ανάγνωση αυτού του αρχείου. Βεβαιώσου ότι είναι έγκυρο υπολογιστικό φύλλο και δοκίμασε ξανά",
        "fill_space_info": "Συμπλήρωσε το πρότυπο με τις πληροφορίες των βοηθητικών χώρων",
        "fill_unit_info": "Συμπλήρωσε το πρότυπο με τις πληροφορίες των ακινήτων",
        "fix_file_upload": "Διόρθωσε τα προβλήματα και ανέβασε ξανά το αρχείο.</br>Τα υπάρχοντα ακίνητα δεν θα αφαιρεθούν, αλλά θα ενημερωθούν αν κάτι άλλαξε στο αρχείο για το κάθε ακίνητο από το τελευταίο ανέβασμα.",
        "fix_file_upload_space": "Διόρθωσε τα προβλήματα και ανέβασε ξανά το αρχείο.</br>Οι υπάρχοντες βοηθητικοί χώροι δεν θα αφαιρεθούν, αλλά θα ενημερωθούν αν κάτι άλλαξε στο αρχείο για τον κάθε βοηθητικό χώρο από το τελευταίο ανέβασμα.",
        "for": "για",
        "import_column_title": "Θέλεις να προσθέσεις {column_type};",
        "import_partial_success": "Η εισαγωγή ολοκληρώθηκε μερικώς. Ακολουθούν τα υπόλοιπα σφάλματα:",
        "import_spaces": "Εισαγωγή βοηθητικών χώρων",
        "import_units": "Εισαγωγή ακινήτων για",
        "lot": "οικόπεδο",
        "lots": "οικόπεδα",
        "no": "όχι",
        "noLevels": "Χωρίς {levels}",
        "phase": "φάση",
        "phases": "φάσεις",
        "plot": "οικόπεδο",
        "select_level_above": "Επίλεξε {level} για να συνεχίσεις",
        "start_upload": "Έναρξη ανεβάσματος",
        "step": "Βήμα",
        "unit_info": "Θα μπορείς να εισαγάγεις ακίνητα μόλις δημιουργηθεί το έργο",
        "unit_limit": "Προσπαθείς να εισαγάγεις περισσότερα ακίνητα από όσα επιτρέπονται. Αφαίρεσε {exceeded_by} ακίνητο/α ή ζήτησέ μας να αυξήσουμε το όριο των ακινήτων σου",
        "units": "ακίνητα",
        "upload_filled_template": "Ανέβασε το συμπληρωμένο πρότυπο",
        "upload_new_file": "Ανέβασμα νέου αρχείου",
        "upload_spaces": "Ανέβασμα βοηθητικών χώρων",
        "upload_units": "Ανέβασμα ακινήτων",
        "uploaded_file": "Ανεβασμένο αρχείο",
        "validations_failed": "Ορισμένοι έλεγχοι απέτυχαν",
        "yes": "ναι"
      },
      "labels": {
        "activate": "Ενεργοποίηση έργου",
        "checkLevels": "Επίλεξε τα επίπεδα που θέλεις να προσθέσεις:",
        "companyInfo": "Στοιχεία οργανισμού",
        "companyNameTitle": "Επωνυμία οργανισμού",
        "congratulationsNewProject": "Συγχαρητήρια για το νέο σου έργο",
        "copyFromTemplate": "Αντιγραφή από πρότυπο έργο (προαιρετικό)",
        "customer_can_create_issue": "Ο πελάτης μπορεί να δημιουργεί παρατηρήσεις",
        "customersCanLogIn": "Οι πελάτες αυτού του έργου μπορούν να συνδεθούν με",
        "deactivate": "Απενεργοποίηση έργου",
        "deactivated": "Απενεργοποιημένο",
        "deactivatedProjects": "Απενεργοποιημένα έργα",
        "download_export": "Λήψη της εξαγωγής μου",
        "downloading_export": "Λήψη...",
        "endsOn": "Λήγει στις {enddate}",
        "export_expiration": "Η εξαγωγή σου είναι έτοιμη για λήψη. Θα παραμείνει διαθέσιμη έως {time}",
        "export_explanation": "Ζήτησε εξαγωγή όλων των δεδομένων σου, μαζί με τις συνομιλίες και τα έγγραφα.",
        "export_failed": "Η εξαγωγή απέτυχε",
        "export_file": "Εξαγωγή του αρχείου μου",
        "export_notification_snack": "Η συλλογή του αρχείου σου μπορεί να διαρκέσει μερικά λεπτά. Θα λάβεις ειδοποίηση μόλις είναι έτοιμο για λήψη.",
        "export_prepared": "Η εξαγωγή σου θα είναι σύντομα έτοιμη για λήψη.",
        "export_preparing": "Προετοιμασία εξαγωγής...",
        "filterProject": "Επιλογή έργου",
        "finalSteps": "Τελευταία βήματα",
        "follow": "Παρακολούθησε {project} για να λαμβάνεις ειδοποιήσεις.",
        "followedProjects": "Τα έργα μου",
        "following": "Παρακολουθείται",
        "general": "Γενικά",
        "importContacts": "Ναι, θέλω να εισαγάγω επαφές πελατών",
        "importInformationSubtitle": "Αντί να προσθέτεις βοηθητικούς χώρους και επαφές έναν έναν, μπορούμε να σε βοηθήσουμε με την εισαγωγή ενός αρχείου CSV. Επίλεξε τα παρακάτω πεδία και θα επικοινωνήσει μαζί σου κάποιο μέλος της ομάδας Ziggu.",
        "importInformationTitle": "Εισαγωγή πληροφοριών;",
        "importSpaces": "Ναι, θέλω να εισαγάγω θέσεις στάθμευσης και αποθήκες",
        "importUnits": "Ναι, θέλω να εισαγάγω ακίνητα και τις πληροφορίες τους",
        "included": "Περιλαμβάνεται",
        "internal": "Εσωτερικά",
        "invoice_subtitle": "Θα σου στείλουμε τιμολόγιο μόνο αν χρειαστεί, π.χ. όταν δεν σου έχουν μείνει ακίνητα στο πακέτο σου.",
        "invoice_title": "Σε ποια διεύθυνση email να στέλνουμε τα τιμολόγιά μας;",
        "isTemplateProject": "Αυτό είναι πρότυπο έργο",
        "levelBuildingExplainer": "Επίλεξέ το αν έχεις πολλά ακίνητα μέσα σε ένα ή περισσότερα κτίρια.",
        "levelPhaseExplainer": "Επίλεξέ το αν το έργο σου χτίζεται σε διαφορετικές φάσεις, κατανεμημένες στον χρόνο.",
        "levelPlotExplainer": "Επίλεξέ το αν το έργο σου αποτελείται από πολλά οικόπεδα.",
        "levelProjectExplainer": "Το έργο είναι το μεγαλύτερο δομικό στοιχείο και είναι απαραίτητο για να ξεκινήσεις.",
        "levelUnitExplainer": "Το ακίνητο είναι το μικρότερο δομικό στοιχείο. Είναι η κατοικία ή το διαμέρισμα που χτίζεις για τους πελάτες σου.",
        "levels": "Δομή έργου",
        "limitReached": "Έφτασες στο όριο των έργων",
        "nameTitle": "Ποιο είναι το όνομα του έργου;",
        "newProjectTitle": "Ας δημιουργήσουμε το νέο σου έργο",
        "noAccess": "Δεν έχεις πρόσβαση σε αυτό το έργο",
        "noFollowedProjects": "Κάνε κλικ στο εικονίδιο ειδοποιήσεων για να παρακολουθήσεις ένα έργο.",
        "noProjects": "Δεν βρέθηκαν έργα",
        "optional_information": "Προαιρετικές πληροφορίες",
        "optional_information_subtitle": "Υπάρχει κάτι άλλο που θέλεις να μας πεις;",
        "otherProjects": "Άλλα έργα",
        "outOfProjects": "Φαίνεται ότι το πακέτο σου δεν έχει άλλα ενεργά έργα.",
        "outOfProjectsContact": "Επικοινώνησε με τη Ziggu για να αυξήσεις το πακέτο σου και να συνεχίσεις να δημιουργείς έργα.",
        "partner_invitation_notice": "Δεν έχει σταλεί ακόμη πρόσκληση σε {partner}. Η πρόσκληση θα σταλεί μόλις προστεθεί {partner} στους συνεργάτες του έργου.",
        "pendingProjects": "Το αίτημα για {first_project_name} καταχωρήθηκε και η Ziggu το ετοιμάζει αυτή τη στιγμή | Καταχωρήθηκαν αιτήματα για {count} έργα και η Ziggu τα ετοιμάζει αυτή τη στιγμή",
        "permission_partner_project": "Συνεργάτης με τον οποίο μοιράζεσαι εύκολα έγγραφα και προτάσεις",
        "permissionsOwnerOnly": "Μόνο τα μέλη της ομάδας με ρόλο «Ιδιοκτήτης» μπορούν να προσθέτουν νέους διαχειριστές έργου",
        "permissionsRoleMaintainer": "Μέλος της ομάδας με πρόσβαση σε αυτό το έργο",
        "project": "Έργο {project}",
        "projectBranding": "Οπτική ταυτότητα έργου",
        "projectIsDeactivated": "Αυτό το έργο είναι απενεργοποιημένο",
        "projectMaintainers": "Διαχειριστές έργου",
        "projectName": "Όνομα έργου",
        "projectStructure": "Δομή έργου",
        "projectStructureSubtitle": "Μπορείς τώρα να προσθέσεις 3 επιπλέον επίπεδα για να οργανώσεις καλύτερα τα ακίνητά σου.</br>Ας δούμε το καθένα, βήμα βήμα.",
        "projectStructureSubtitleOld": "Η δομή του έργου ορίζεται μία φορά, στην αρχή του έργου",
        "project_label": "Έργο",
        "project_partners": "Συνεργάτες έργου",
        "projects": "Έργα",
        "remove_project_partner_prohibited": "Δεν μπορεί να αφαιρεθεί {partner} από τους συνεργάτες του έργου, γιατί έχει προστεθεί σε αποφάσεις αυτού του έργου.",
        "remove_project_partner_prohibited_label": "Ο συνεργάτης έργου δεν μπορεί να αφαιρεθεί",
        "searchProject": "Αναζήτηση έργου",
        "searchProjects": "Αναζήτηση έργου",
        "selectATemplateProject": "Επίλεξε ένα πρότυπο έργο",
        "selected": "Επιλεγμένο",
        "showProject": "Εμφάνιση έργου",
        "spaces": "Βοηθητικοί χώροι",
        "startsOn": "Ξεκινά στις {startdate}",
        "step1Info": "Ας δούμε μερικές λεπτομέρειες για να ξεκινήσεις.",
        "step1Title": "Συγχαρητήρια για το νέο σου έργο",
        "step2Info": "Σε ποιον οργανισμό να εκδώσουμε το τιμολόγιο;",
        "step2Title": "Στοιχεία τιμολόγησης",
        "step3Title": "Χρειάζονται ενδιάμεσα επίπεδα;",
        "step4Info": "Τι γίνεται μετά; Η Ziggu θα ετοιμάσει {project} σε 3 έως 5 εργάσιμες ημέρες. Θα ειδοποιηθείς μόλις είναι όλα έτοιμα.",
        "templateProjects": "Πρότυπα έργα",
        "unFollow": "Δεν θα λαμβάνεις πια ειδοποιήσεις για {project}.",
        "underConstruction": "Υπό κατασκευή",
        "units": "Ακίνητα",
        "unitsActiveRemaining": "Διαθέσιμα ακίνητα",
        "unitsAllotted": "Κατανεμημένα ακίνητα",
        "unitsCountSubtitle": "Πόσα ακίνητα;",
        "unselected": "Κάνε κλικ για επιλογή",
        "youAreEditingTemplateProject": "Επεξεργάζεσαι ένα πρότυπο έργο",
        "you_have_inbound_emails": "Έχεις 1 μη επεξεργασμένο εισερχόμενο email | Έχεις {number} μη επεξεργασμένα εισερχόμενα email"
      },
      "messages": {
        "units_count_max": "Αν θέλεις να δημιουργήσεις περισσότερα ακίνητα, επικοινώνησε μαζί μας μέσω του κουμπιού συνομιλίας."
      },
      "modals": {
        "add_project": {
          "step_1": {
            "title": "Ας ετοιμάσουμε το νέο σου έργο"
          },
          "step_3": {
            "subtitle": "Κάνε κλικ στις κάρτες για να ενεργοποιήσεις τα ενδιάμεσα επίπεδα.",
            "title": "Χρειάζεσαι ενδιάμεσα επίπεδα;"
          },
          "step_4": {
            "info": "Τα πρότυπα αποφάσεων και ερωτηματολογίων μπορούν να εισαχθούν μόλις δημιουργηθούν τα ακίνητα αυτού του έργου.",
            "placeholder": "Επίλεξε ένα έργο ή άφησέ το κενό αν δεν θέλεις να αντιγράψεις από πρότυπο",
            "title": "Θέλεις να ξεκινήσεις από πρότυπο;"
          }
        }
      },
      "navigation": {
        "backToProjects": "Επιστροφή στα έργα"
      },
      "notifications": {
        "emailHasBeenCopied": "Η διεύθυνση email αντιγράφηκε",
        "pictureChangedSuccessfully": "Η εικόνα ενημερώθηκε. Οι αλλαγές μπορεί να χρειαστούν έως μία ώρα για να φανούν.",
        "tokenCopied": "Το token αντιγράφηκε με επιτυχία",
        "urlHasBeenCopied": "Το URL αντιγράφηκε με επιτυχία"
      },
      "placeholders": {
        "employees": {
          "none": {
            "subtitle": "Δεν έχεις πρόσβαση σε κανένα έργο. Ζήτησε από ένα μέλος της ομάδας με ρόλο «Ιδιοκτήτης» να σου δώσει πρόσβαση.",
            "title": "Κανένα έργο"
          }
        },
        "partners": {
          "noProjectSubtitle": "Θα ειδοποιηθείς μόλις σου ανατεθεί ένα νέο έργο",
          "noProjectTitle": "Κανένα έργο ακόμη"
        }
      },
      "snackbars": {
        "duplicate": "Η αντιγραφή ξεκίνησε και μπορεί να διαρκέσει λίγο. Ανανέωσε τη σελίδα σε μερικά λεπτά."
      },
      "sort": {
        "nameAsc": "Όνομα Α → Ω",
        "nameDesc": "Όνομα Ω → Α",
        "newest": "Νεότερα πρώτα",
        "oldest": "Παλαιότερα πρώτα"
      },
      "toasts": {
        "activateSuccess": "Το έργο {project_name} ενεργοποιήθηκε με επιτυχία.",
        "deactivateSuccess": "Το έργο {project_name} απενεργοποιήθηκε με επιτυχία.",
        "duplicate": "Το έργο δημιουργήθηκε, αλλά η αντιγραφή του προτύπου μπορεί να διαρκέσει μερικά λεπτά."
      },
      "tooltip": {
        "hasNoActiveUnits": "Δεν έχει ενεργά ακίνητα",
        "turnOffNotifications": "Απενεργοποίηση ειδοποιήσεων για {project}",
        "turnOnNotifications": "Ενεργοποίηση ειδοποιήσεων για {project}"
      },
      "validation": {
        "addressInformationRequired": "Απαιτούνται στοιχεία διεύθυνσης",
        "companyNeedName": "Απαιτείται επωνυμία οργανισμού",
        "companyNeedVatNumber": "Απαιτείται ΑΦΜ",
        "dateAfter": "Η ημερομηνία πρέπει να είναι μετά την ημερομηνία έναρξης",
        "lessThanOrEqual": "Ο αριθμός πρέπει να είναι μικρότερος ή ίσος με {max_number}",
        "maxLength": "Το όνομα μπορεί να έχει έως {length} χαρακτήρες",
        "nameAlreadyTaken": "Το όνομα χρησιμοποιείται ήδη σε αυτό το έργο",
        "needName": "Απαιτείται τίτλος",
        "needNumber": "Πρέπει να είναι αριθμός (π.χ. 850)",
        "needUnitsCount": "Απαιτείται ο αριθμός ακινήτων"
      }
    }
  }
}
